
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import BoardPage from './pages/BoardPage';
import ChatPage from './pages/ChatPage';
import ListPage from './pages/ListPage';
import LoginPage from './pages/LoginPage';
import NoticePage from './pages/NoticePage';
// import ShareView from './pages/ShareView';

const App = () => {

	const { logged } = useSelector((state) => state.AuthReducer);

	return (
		<Routes>
			<Route path="/" element={<LoginPage />} />

			<Route
				path="/chat"
				element={logged ? <ChatPage /> : <Navigate to="/" replace />}
			/>

			<Route
				path="/list"
				element={logged ? <ListPage /> : <Navigate to="/" replace />}
			/>

			<Route
				path="/board"
				element={logged ? <BoardPage /> : <Navigate to="/" replace />}
			/>

			<Route
				path="/notice"
				element={logged ? <NoticePage /> : <Navigate to="/" replace />}
			/>

			{/* <Route
				path="/shareview"
				element={logged ? <ShareView /> : <Navigate to="/" replace />}
			/> */}
		</Routes>
	);

};


export default App;
